import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ClockIcon, SparklesIcon } from 'lucide-react';
export function HookSection() {
  return <section className="py-10 px-6 lg:px-8 bg-tea-cream relative" data-id="element-181">
      <div className="max-w-3xl mx-auto" data-id="element-182">
        <FadeIn data-id="element-183">
          <div className="flex justify-center mb-6" data-id="element-184">
            <div className="w-16 h-16 rounded-full bg-tea-sage/50 flex items-center justify-center text-tea-green" data-id="element-185">
              <ClockIcon className="w-8 h-8" data-id="element-186" />
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-187">
          <p className="text-xl md:text-2xl font-heading text-tea-charcoal leading-relaxed text-center mb-8" data-id="element-188">
            "Sé exactamente qué sientes el domingo a las 8:00 PM. Ese nudo en el
            estómago porque mañana tu tiempo vuelve a pertenecerle a alguien
            más. Sientes que tus ingresos tienen un techo y que, por más que te
            esfuerces, nunca es suficiente para construir la libertad que
            buscas."
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-189">
          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-tea-sage/60 relative overflow-hidden" data-id="element-190">
            <div className="absolute top-0 left-0 w-2 h-full bg-tea-gold" data-id="element-191"></div>
            <SparklesIcon className="w-8 h-8 text-tea-gold mb-6" data-id="element-192" />
            <p className="text-lg text-tea-charcoal/80 font-body leading-relaxed" data-id="element-193">
              <strong className="text-tea-green font-semibold" data-id="element-194">
                ¿Y si pudieras usar tus noches para construir la salida?
              </strong>{' '}
              No hablo de un curso teórico, sino de un plan de acción real
              donde, en solo 21 días, estarás sosteniendo tu primer blend de
              autor, listo para ser entregado a tu primer cliente.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}